import type { OAuthProvider } from './providers';

/**
 * Названия провайдеров отдельно от их иконок: `providers.ts` тянет React-компоненты иконок,
 * а те — виртуальные модули `~icons/*`, которых нет в окружении unit-тестов. Здесь чистые
 * строки, поэтому подпись можно проверять тестом, не поднимая всю сборку.
 */
export const PROVIDER_FULL_NAMES: Record<OAuthProvider, string> = {
  DISCORD: 'Discord',
  GOOGLE: 'Google',
  APPLE: 'Apple',
  STEAM: 'Steam',
  EPIC_GAMES: 'Epic Games',
  RIOT_GAMES: 'Riot Games',
  BUNGIE: 'Bungie',
  XBOX: 'Xbox',
};

/**
 * Подпись строки провайдера в настройках: имя аккаунта, если провайдер его отдал,
 * иначе название самого провайдера.
 *
 * Пустую строку надо считать отсутствующим значением. `displayName ?? email` этого не делает —
 * `??` реагирует только на null/undefined, а сюда приходит именно `''` (родитель нормализует
 * `account.email ?? ''`). Из-за этого у привязанного аккаунта без имени и почты подпись
 * пропадала совсем: на проде так выглядели бы все 965 привязок Steam, 233 Discord и 14 Riot.
 *
 * Последний фолбэк — название провайдера, а не сырой `id`: Steam ID64 или числовой Google sub
 * в строке настроек человеку ничего не говорят. Привязан аккаунт или нет, видно по тумблеру.
 */
export const getProviderLabel = (
  provider: OAuthProvider,
  account?: { id?: string | null; displayName?: string | null; email?: string | null } | null
) => {
  const fullName = PROVIDER_FULL_NAMES[provider];

  if (!account?.id) {
    return fullName;
  }

  return account.displayName?.trim() || account.email?.trim() || fullName;
};
